// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b7c55484","667":"e920a4fb"}[chunkId] + ".chunk.js";
};